import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getThemeTokens } from '../tokens';

export const styledMuiSelect = (
  theme: Theme,
): BackstageOverrides['MuiSelect'] => ({
  root: {
    fontSize: `${theme.typography.body1.fontSize} !important`,
    marginBottom: '0px !important',
    minHeight: theme.spacing(5),
  },
  icon: {
    color: `${getThemeTokens(theme).textSecondary} !important`,
  },
});
